import { userApiClient } from "@/lib/userApiClient";

export interface SocialMediaLink {
  id: number;
  name: string;
  url: string;
  svg_code: string;
  created_at: string;
  updated_at: string;
}

class SocialMediaLinkService {
  async getLinks(): Promise<SocialMediaLink[]> {
    const response = await userApiClient.get<{ links: SocialMediaLink[] }>(
      "/social_media_links"
    );
    return response.links;
  }
}

export const socialMediaLinkService = new SocialMediaLinkService();
